import { render, staticRenderFns } from "./OrderCardHistory.vue?vue&type=template&id=76036a26&scoped=true&"
import script from "./OrderCardHistory.vue?vue&type=script&lang=js&"
export * from "./OrderCardHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardHistory.vue?vue&type=style&index=0&id=76036a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76036a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
